export default __webpack_public_path__ + "static/media/group.854bd8e4.svg";